import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import PlaceholderWrapper from "../../Common/PlaceholderWrapper";
import GridView from "@mnjsplatform/components/lib/common/GridView/GridView";
import ComplexParam from "@mnjsplatform/components/lib/common/ComplexParam";
import SearchBar from "@mnjsplatform/components/lib/common/SearchBar";
import textUtils from "@mnjsplatform/data/lib/utils/textUtils";
import MessageBox from "@mnjsplatform/components/lib/common/MessageBox";
import ReportPlaceholder from "../../Common/ReportPlaceholder";
import i18next from "i18next";

class PeopleBoard extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            selectedTabNums: [], reportErrorMessage: ""
        };
    }

    componentDidMount() {
        this.initialize();
    }

    async initialize() {
        try {
            await this.props.dispatch(this.props.listSubForPO.reset());
            await this.props.dispatch(this.props.listSubForPO.execute({}, {withParams: true}));
        } catch (e) {
            console.error(e);
        }
    }

    onPersonClick = (rowIndex, row, e) => {
        this.setState((state, props) => {
            let newSelectedTabNums;
            if (row.IsChecked === 0) {
                newSelectedTabNums = state.selectedTabNums.filter(tn => true);
                newSelectedTabNums.push(row.TabNum);
            } else {
                newSelectedTabNums = state.selectedTabNums.filter(tn => tn !== row.TabNum);
            }
            return {
                selectedTabNums: newSelectedTabNums
            };
        });
    };

    renderParam = (h) => {
        return (<>
            <div className="row mb-2">
                <div className="col-md-4">
                    {/*Количество уровней подчиненности (<span style={{color: "red"}}>не более 10 уровней</span>):*/}
                    {h.lbl("NumSub")}
                </div>
                <div className="col-md-1">
                    {h.ed("NumSub")}
                </div>
            </div>

            <div className="row mb-2">
                <div className="col-md-12">
                    {h.ed("AdmStructName")}
                </div>
            </div>

            <div className="row mb-2">
                <div className="col-md-4">
                    {i18next.t("SubordinateSearch")}:
                </div>
                <div className="col-md-8" style={{height: "32px"}}>
                    <SearchBar dataItem={this.props.listSubForPO}
                               afterApplyValue={this.afterApplyFilter}
                    />
                </div>
            </div>
        </>);
    };

    renderGridRow = (row, rowIndex, renderRowDefault) => {
        let rRow = {
            ...row, IsChecked: this.state.selectedTabNums.some(tn => tn === row.TabNum) ? 1 : 0
        };
        return renderRowDefault(rRow, rowIndex);
    };

    renderGridCell = (row, fieldInfo, fieldIndex, renderCellDefault) => {
        if (fieldInfo.Name === "IsChecked") {
            return <input type="checkbox" className="checkbox" checked={row.IsChecked} style={{cursor: "pointer"}}
                          onChange={() => {
                          }}/>;
        } else {
            return renderCellDefault(row, fieldInfo, fieldIndex);
        }
    };

    afterApplyFilter = () => {
        if (this.props.listSubForPO.isInitialized && this.state.selectedTabNums.length > 0 && this.state.selectedTabNums.some(tn => !this.props.listSubForPO.dataTable().some(r => r.TabNum === tn))) {
            this.setState({selectedTabNums: []});
        }
    };

    gridRowStyleProvider = (rowIndex, row) => {
        let style = {cursor: "pointer"};
        if (row.IsChecked) {
            return {
                ...style, fontWeight: "bold", backgroundColor: "lightgrey"
            };
        }
        return style;
    };

    renderReportParams = (h) => {
        return (<div className="row">
            <div className="col-md-3">
                {h.lbl("YearLabel")}
            </div>
            <div className="col-md-3">
                {h.ed("YearLabel")}
            </div>
        </div>);
    };

    renderReports = () => {
        const doReport = async (e, reportParamsItem, build) => {
            const getTabNums = () => {
                let result = this.state.selectedTabNums.map(tn => ({TabNum: tn}));
                if (result.length === 0) {
                    result = this.props.listSubForPO.dataTable().map(r => ({TabNum: r.TabNum}));
                }
                return result;
            }

            e.preventDefault();

            let dateParam = this.reportParamsR.getField(0, "YearDateBegin");
            if (!dateParam) {
                this.setState({reportErrorMessage: i18next.t("PeopleBoard_SelectYear")});
                return;
            }

            await this.props.dispatch(reportParamsItem.setField(0, "YearDateBegin", dateParam));
            await this.props.dispatch(reportParamsItem.setField(0, "TabNumSet", getTabNums()));

            await build();
        }

        return (<>
            <PlaceholderWrapper placeholderId="30"
                                title={<><i className='fa fa-table'/> {i18next.t("Reports")}</>}
                                showSplitterLine={false}
                                canCollapse={false}
            >
                <ReportPlaceholder reportKey="KP_ListProfileR" reportId="KP_ListProfileR" title={i18next.t("PeopleBoard_SubordinateProfile")}>
                    {(reportParamsItem, build) => {
                        this.reportParamsR = reportParamsItem;
                        return (<>
                            <ComplexParam dataItem={reportParamsItem}
                                          readOnly={false}
                                          showSearchBar={false}
                                          showApplyButton={false}
                                          autoApplyParams={false}
                                          rootPath="/"
                                          renderParams={this.renderReportParams}
                            />
                            <button className="btn mn-btn-link" onClick={(e) => doReport(e, reportParamsItem, build)}>
                                {i18next.t("PeopleBoard_SubordinateProfileRus")}
                            </button>
                        </>);
                    }}
                </ReportPlaceholder>
                <br/>
                <ReportPlaceholder reportKey="KP_ListProfileE" reportId="KP_ListProfileE" title={i18next.t("PeopleBoard_SubordinateProfileEng")}>
                    {(reportParamsItem, build) => {
                        return (<>
                            <button className="btn mn-btn-link" onClick={(e) => doReport(e, reportParamsItem, build)}>
                                {i18next.t("PeopleBoard_SubordinateProfileEng")}
                            </button>
                        </>);
                    }}
                </ReportPlaceholder>
                <br/>
                <ReportPlaceholder reportKey="EOD_PBList" reportId="EOD_PBList" title={i18next.t("People_Board_1")}>
                    {(reportParamsItem, build) => {
                        return (<>
                            <button className="btn mn-btn-link" onClick={(e) => doReport(e, reportParamsItem, build)}>
                                {i18next.t("People_Board_1")}
                            </button>
                        </>);
                    }}
                </ReportPlaceholder>
                <br/>
                <ReportPlaceholder reportKey="RatProcRepPerso" reportId="RatProcRepPerso" title={i18next.t("People_Board_2")}>
                    {(reportParamsItem, build) => {
                        return (<>
                            <button className="btn mn-btn-link" onClick={(e) => doReport(e, reportParamsItem, build)}>
                                {i18next.t("People_Board_2")}
                            </button>
                        </>);
                    }}
                </ReportPlaceholder>
                <br/>
                <ReportPlaceholder reportKey="KpProfileExtend" reportId="KpProfileExtend" title={i18next.t("People_Board_3")}>
                    {(reportParamsItem, build) => {
                        return (<>
                            <button className="btn mn-btn-link" onClick={(e) => doReport(e, reportParamsItem, build)}>
                                {i18next.t("People_Board_3")}
                            </button>
                        </>);
                    }}
                </ReportPlaceholder>
            </PlaceholderWrapper>

            <MessageBox title={i18next.t("ReportBuilding")}
                        messageText={this.state.reportErrorMessage}
                        visible={!!this.state.reportErrorMessage}
                        onClose={() => {
                            this.setState({reportErrorMessage: ""})
                        }}
            />
        </>);
    }

    render() {
        let cnt = this.props.listSubForPO.rowsCount();
        let gridTitleText = i18next.t("SubordinateList_GridTitle", {people_count: textUtils.pluralize_i18next(cnt, "peopleCountPostfix")});

        return (<>
            <PlaceholderWrapper placeholderId="10"
                                title={<><i className='fa fa-filter'/> {i18next.t("PeopleBoard_Title")}</>}
                                showSplitterLine={false}
                                canCollapse={false}
            >
                <ComplexParam dataItem={this.props.listSubForPOParams}
                              readOnly={false}
                              showSearchBar={false}
                              showApplyButton={false}
                              autoApplyParams={true}
                              rootPath="/"
                              parentDataItem={this.props.listSubForPO}
                              renderParams={this.renderParam}
                              afterApplyParams={this.afterApplyFilter}
                />
            </PlaceholderWrapper>

            <PlaceholderWrapper placeholderId="20"
                                title={<><i className='fa fa-table'/> {gridTitleText}</>}
                                staticTitle={i18next.t("SubordinateList_GridTitle")}
                                showSplitterLine={false}
                                canCollapse={false}
            >
                <GridView dataItem={this.props.listSubForPO}
                          onRowClick={this.onPersonClick}
                          renderRow={this.renderGridRow}
                          updateStateFlag={{f: this.state.selectedTabNums}}
                          rowStyleProvider={this.gridRowStyleProvider}
                          renderCell={this.renderGridCell}
                />
            </PlaceholderWrapper>
            <PlaceholderWrapper placeholderId="40"
                                title={<><i className='fa fa-link'/> {i18next.t("Links")}</>}
                                showSplitterLine={false}
                                canCollapse={false}
            >
                <a href={`${this.props.appParams.EODPortal}/Pers/Wf.aspx?mn_cmd=LAAAAAQAAABHb1RvAAAAAAEAAABzCQAAAFdlYkZvcm1JZAYAAABSYXRTdWI=`}
                   target="_blank">{i18next.t("People_Board_4")}
                </a>
            </PlaceholderWrapper>
            {this.renderReports()}
        </>);
    }
}

PeopleBoard.propTypes = {
    dispatch: PropTypes.func.isRequired, listSubForPO: PropTypes.object, listSubForPOParams: PropTypes.object
};

PeopleBoard.defaultProps = {};

function mapStateToProps(state, ownProps) {
    return {
        listSubForPO: state.peopleBoardState.PeopleBoard_ListSubForPO,
        listSubForPOParams: state.peopleBoardState.PeopleBoard_ListSubForPOParams,
        appParams: state.appState.appParams
    }
}

export default connect(mapStateToProps)(PeopleBoard);